import { TableCell, TableRow } from '@mui/material'
import React from 'react'

function UserTab({users}) {
  return (
    <div>
<div style={{width:"100%",display:"flex",justifyContent:"space-between"}}  >
        <p className="px-5-dd text-black text-left font-bold" style={{width: "25%"}}>UserName</p>
        <p className="px-5-dd text-black text-left font-bold" style={{width: "25%"}}>Email</p>
        <p className="px-5-dd text-black text-left font-bold" style={{width: "50%",textAlign:"right"}}>Role</p>
      </div>
{users.length > 0 && users.map((item, index) => (
      <div style={{marginTop:"10px",borderRadius:'10px',border: "1px solid rgba(229, 229, 229, 1)",width:"100%",display:"flex",justifyContent:"space-between"}} key={index}>
        <p className="px-5-dd text-black text-left font-black" style={{width: "25%"}}>{item.userName}</p>
        <p className="px-5-dd text-black text-left font-black" style={{width: "25%"}}>{item?.email}</p>
        <p className="px-5-dd text-black text-left font-black" style={{width: "50%",textAlign:"right"}}>{item?.role}</p>

      </div>
    ))}

     
    </div>
  )
}

export default UserTab
